import { render, staticRenderFns } from "./index.vue?vue&type=template&id=53c3658a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=53c3658a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c3658a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\0.资料\\项目\\girdear_mall_center_web\\node_modules\\.store\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53c3658a')) {
      api.createRecord('53c3658a', component.options)
    } else {
      api.reload('53c3658a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=53c3658a&scoped=true", function () {
      api.rerender('53c3658a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SeeExample/index.vue"
export default component.exports